export const isMobile = () => window.matchMedia("(max-width: 767px)").matches;
export const isTouch = () => window.matchMedia("(max-width: 1023px)").matches;
export const isDesktop = () => window.matchMedia("(min-width: 1024px)").matches;

export const isLaunchedFromHome = () => document.location.hash === "#home";
